<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/edu/packagelist' }"
          >课包管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>课详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main-box">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">
            已添加书籍
            <span style="font-size: 14px" v-if="doWhat == 'edit'"
              >（可拖拽进行排序）</span
            >
          </h3>
          <div class="panel-content">
            <!--
            <el-form :inline="true" :model="formBook" label-width="90px">
              <el-form-item label="书籍ID">
                <el-input v-model="formBook.id" placeholder="请输入阿拉伯数字搜索"></el-input>
              </el-form-item>
              <el-form-item label="名称:">
                <el-input v-model="formCourse.name"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onQuery">搜索</el-button>
              </el-form-item>
            </el-form>
            -->
            <el-table
              ref="multipleTable"
              :data="bookData"
              border
              row-key="id"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="50" v-if="doWhat == 'edit'"></el-table-column>
              <el-table-column
                prop="rid"
                label="书籍ID"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <a @click="viewBook(scope.row)" style="color: #1d90e6">{{
                    scope.row.rid
                  }}</a>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="书籍名称"
                align="center"
                width="180"
              >
                <template slot-scope="scope">
                  <a @click="viewBook(scope.row)" style="color: #1d90e6">{{
                    scope.row.name
                  }}</a>
                </template>
              </el-table-column>
              <el-table-column
                prop="dbName"
                label="CP"
                align="center"
                min-width="110"
              ></el-table-column>
              <el-table-column
                prop="count"
                label="品牌"
                align="center"
                width="130"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.content.brand }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="updated_at"
                label="级别"
                align="center"
                width="130"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.content.level }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="排序"
                align="center"
                width="130"
                type="index"
              >
                <!-- <template slot-scope="scope">
                  {{scope.row.ind}} -->
                <!-- <InputNumber
                    size="small"
                    :min="1"
                    v-model="scope.row.ind"
                    :disabled="doWhat=='view'"
                    @on-change="(value) => handleNumberChange(value, scope.row, scope.$index)" -->
                <!-- ></InputNumber> -->
                <!-- <el-input-number
                    :key="scope.row.ind"
                    size="small"
                    :min="1"
                    :ref="`name`"
                    :value="scope.row.ind"
                    :disabled="doWhat == 'view'"
                    @change="
                      (value) => handleChange(value, scope.row, scope.$index)
                    "
                  ></el-input-number> -->
                <!-- </template> -->
              </el-table-column>
              <el-table-column
                prop="clevel"
                label="上下架状态"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.clevel == 0" type="danger"
                    >已下架</el-tag
                  >
                  <el-tag v-if="scope.row.clevel == 4" type="info"
                    >审核通过</el-tag
                  >
                  <el-tag v-if="scope.row.clevel == 5" type="success"
                    >已上架</el-tag
                  >
                  <el-tag v-if="scope.row.clevel == 2" type="primary"
                    >编辑中</el-tag
                  >
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="操作"
                show-overflow-tooltip
                align="center"
                width="160"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="shareBox(scope.row)"
                    >分享</el-button
                  >
                </template>
              </el-table-column> -->
            </el-table>
            <el-button
              type="danger"
              @click="handleDelete"
              v-if="doWhat == 'edit'"
              style="margin-top: 8px"
              >删除</el-button
            >
              
            <el-button type="primary" @click="shangxiajia(5)" icon="arrow-up" v-if="doWhat == 'edit'"
              >上架</el-button
            >
            <el-button type="info" @click="shangxiajia(0)" icon="arrow-down" v-if="doWhat == 'edit'"
              >下架</el-button
            >
          </div>
        </div>
      </Card>
      <el-button
        type="primary"
        style="margin-left: 49%; margin-top: 30px; margin-bottom: 50px"
        @click="confirmSubmit"
        >确定</el-button
      >

      <el-dialog
        title=""
        :visible.sync="dialogTableVisible"
        style="width: 50%; text-align: center; margin: 0 auto"
      >
        <p style="text-align: center; font-size: 16px; margin-bottom: 20px">
          分享绘本：<span>{{ bookName }}</span>
        </p>
        <el-button
          type="primary"
          size="large"
          style="margin: 0 auto"
          @click="doCopy()"
        >
          复制分享链接</el-button
        >
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { ApiMessage, formatDate } from "@/utils/util";
import Sortable from "sortablejs";
export default {
  name: "packageCourseDetail",
  components: {},
  data() {
    return {
      bookData: [],
      currId: null,
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      doWhat: "",
      multipleSelection: [],
      dialogTableVisible: false,
      url: "",
      mid: "",
      bookName: "",
    };
  },
  created() {
    if (this.$route.query.id != undefined) {
      // debugger
      this.currId = `${this.$route.query.id}`;
      this.fetchBookRes();
    }
    
    this.doWhat = this.$route.query.do;
  },
  mounted() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.rowDrop();
  },

  watch: {},
  methods: {
    share() {
      this.$router.push({
        name: "share",
      });
    },
    //行拖拽
    rowDrop() {
      if (this.doWhat != "view") {
        //详情页面不生效
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        console.log("tbody", tbody);
        const _this = this;
        Sortable.create(tbody, {
          onEnd({ newIndex, oldIndex }) {
            const currRow = _this.bookData.splice(oldIndex, 1)[0];
            _this.bookData.splice(newIndex, 0, currRow);

            // _this.bookData = _this.bookData.sort(function(a, b) {

            //   return a.sort - b.sort
            // })
            //   console.log(_this.bookData, 'sss')
          },
        });
      }
    },
    doCopy() {
      // debugger
      // console.log(mid)
      // 分享接口
      let vm = this;
      var appId = this.$API.APPID;
      var params = {
        appId: appId, //必须
        bookId: this.mid, //必须，书籍ID
      };
      this.$axios
        .post("/edu/eduAdmin/book/create_share_url", params)
        .then((response) => {
          var m = response.data;
          if (m.rc == 0) {
            // debugger

            this.url = m.data.url; //测试
            // this.url = m.data.urls; //本地
            var name = this.url.substring(this.url.indexOf("=") + 1);
            console.log(name, "o0ooiuuuuijghjfghj");
            debugger
            this.$copyText(this.url).then(
              function (e) {
                alert("复制成功");
                vm.dialogTableVisible = false;
              },

              function (e) {
                alert("复制失败，请手动复制链接地址：\n"+e.text);
                console.log(e);
              }
            );
          } else {
            // alert(m.msg);
          }
        });
      // debugger
    },
    // 上架
    shangxiajia(clevel) {
      if (this.multipleSelection.length == 0) {
        alert("请先选择书籍");
        return;
      }
      let ids = [];
      for (let i in this.multipleSelection) {
        let temp = {
          dbId: this.multipleSelection[i].dbId,
          id: this.multipleSelection[i].rid,
        };
        ids.push(temp);
      }
      let param = {
        appId: this.$API.APPID,
        ids: ids,
        clevel: clevel,
      };
      this.sendUpDownBook(param).then((res) => {
        if (res == "success") {
          this.fetchBookRes();
        }
      });
    },
    sendUpDownBook(param) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/aries-api/resource/online", param)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              this.$Message.success("操作成功!");
              resolve(response.data.msg);
            } else {
              alert(response.data.msg);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    handleChange(va, v2, v3) {
      this.bookData[v3].ind = va;
      this.bookData.splice();
      // console.log(this.$refs)
      // this.$refs.name.$children[0].$listeners.blur()
      // debugger
      // console.log(this.bookData, 'ss')
    },
    fetchBookRes() {
      let params = {
        appId: this.$API.APPID,
        id: Number(this.currId),
        page: this.queryParams.page,
        pageSize: 500, //this.queryParams.pageSize,
        sort: "sort,asc"
      };

      this.$axios
        .post("/aries-api/album/resList", params)
        .then((response) => {
          console.log(response);
          var m = response.data;
          if (m.result == 0) {
            this.bookData = m.data.list;
            this.pageTotal = m.data.pager.total;
            let startPageNum =
              (this.queryParams.page - 1) * this.queryParams.pageSize;
            for (let i in this.bookData) {
              this.bookData[i].content = JSON.parse(this.bookData[i].content);
              this.bookData[i].ind = Number(i) + 1 + startPageNum;
            }
            console.log(this.bookData);
          } else {
            alert(m.msg);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchBookRes();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchBookRes();
    },
    viewBook(book) {
      let routeUrl = this.$router.resolve({
        name: "addbook",
        query: {
          cpid: book.dbId,
          bookid: book.rid,
          do: "view",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleNumberChange(newIndex, book, oldIndex) {
      if (newIndex != null) {
        let changeNum = 0;
        oldIndex += 1;
        if (newIndex > oldIndex) {
          this.bookData.splice(newIndex, 0, book);
          this.bookData.splice(oldIndex - 1, 1);
          changeNum = newIndex - oldIndex;
          this.$nextTick(() => {
            for (let i = 0; i < changeNum; ++i) {
              let temp = this.bookData[i + oldIndex - 1];
              temp.ind = this.bookData[i + oldIndex - 1].ind - 1;
              this.$set(this.bookData, i + oldIndex - 1, temp);
            }
          });
        } else if (newIndex < oldIndex) {
          this.bookData.splice(newIndex - 1, 0, book);
          this.bookData.splice(oldIndex, 1);
          changeNum = oldIndex - newIndex;
          this.$nextTick(() => {
            for (let i = 0; i < changeNum; ++i) {
              let temp = this.bookData[i + newIndex];
              temp.ind = this.bookData[i + newIndex].ind + 1;
              this.$set(this.bookData, i + newIndex, temp);
            }
          });
        }
      }
    },
    checkBookDataLen(array) {
      return new Set(array).size !== array.length;
    },
    // 确定提交
    confirmSubmit() {
      if (this.doWhat == "view") {
        this.$router.push({
          name: "courseList",
        });
      } else {
        let res = [];

        // // 先判断bookData中是否存在相等的ind
        // var fiterInd = () => {
        //   var indList = this.bookData.map((item) => item.ind);
        //   // console.log(indList, 'int')
        //   return this.checkBookDataLen(indList);
        // };
        // if (fiterInd()) {
        //   alert("排序重复，请重新填写！");
        //   return;
        // }
        for (let i = 0; i < this.bookData.length; ++i) {
          let tmp = {
            id: this.bookData[i].rid,
            dbId: this.bookData[i].dbId,
            sort: i + 1,
          };
          res.push(tmp);
        }
        let params = {
          appId: this.$API.APPID,
          id: Number(this.currId),
          resList: res,
        };
        // console.log(params)
        this.$axios
          .post("/aries-api/album/saveRes", params)
          .then((response) => {
            console.log(response);
            let m = response.data;
            if (m.result == 0) {
              this.$router.push({ name: "courseList" });
            } else {
              ApiMessage(this, m.msg, "error");
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
          });
      }
    },
    handleDelete() {
      if (this.multipleSelection.length == 0) {
        alert("请至少选择一个要删除的书籍");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除资源</li></ul>",
        onOk: () => {
          let len = this.multipleSelection.length;
          let resList = [];
          for (let i = 0; i < len; ++i) {
            let temp = {
              id: this.multipleSelection[i].rid,
              dbId: this.multipleSelection[i].dbId,
            };
            resList.push(temp);
          }
          let params = {
            appId: this.$API.APPID,
            id: Number(this.currId),
            resList: resList,
          };
          this.$axios
            .post("/aries-api/album/delRes", params)
            .then((response) => {
              console.log(response);
              let m = response.data;
              if (m.result == 0) {
                this.fetchBookRes();
                this.$Message.success("删除成功!");
              } else {
                ApiMessage(this, m.err, "error");
              }
            })
            .catch((error) => {
              ApiMessage(this, error.toString(), "error");
            });
        },
      });
    },

    // 分享
    shareBox(data) {
      // debugger
      this.dialogTableVisible = true;
      this.mid = data.mid;
      this.bookName = data.name;
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>



// WEBPACK FOOTER //
// packageCourseDetail.vue?ea5fb57e